<template>
  <vs-popup class="add-new-company-holiday"
            id="popup"
            :title="isCreateMode ? 'ADD COMPANY HOLIDAY' : 'UPDATE COMPANY HOLIDAY'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Date</small>
                <flat-pickr
                  :config="{dateFormat: 'Y-m-d'}"
                  class="hidden"
                  v-model="form.date"
                  placeholder="Choose Date"/>

                <flat-pickr :config="{dateFormat: 'Y-m-d'}" class="w-full" v-model="form.date"
                            placeholder="Choose Date"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-textarea class="mb-0" v-model="form.name" height="150px"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-holidays-setting'" button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="form = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const HolidayRepository = RepositoryFactory.get('holiday');

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        address: {}
      },
      isCreateMode: true
    }
  }

  export default {
    name: 'AddNewCompanyHolidayPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          if (!!id) {
            this.id = id
            this.isCreateMode = false
            await this.fetchHolidayDetails()
          } else {
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
      async fetchHolidayDetails() {
        this.$vs.loading();
        try {
          const {data} = (await HolidayRepository.detHolidayDetails(this.id)).data
          this.form = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreateSite() {
        const vue = this;
        this.$vs.loading();
        try {
          if (this.isCreateMode) {
            await HolidayRepository.createCompanyHoliday(this.form);
            this.showSuccessMessage('Company holiday added!');
          } else {
            await HolidayRepository.updateCompanyHoliday(this.id, this.form);
            this.showSuccessMessage('Company holiday updated!');
          }
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close();
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
    },
    components: {
      flatPickr,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-company-holiday >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
